import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// Views
import Dashboard from './views/Dashboard';
import CustomerList from './views/CustomerList';
import Account from './views/Account';
import SignUp from './views/SignUp';
import SignIn from './views/SignIn';
import Support from './views/Support';
import ForgotPassword from './views/ForgotPassword';
import ResetPassword from './views/ResetPassword';
import UnderDevelopment from './views/UnderDevelopment';
import NotFound from './views/NotFound';
import PrivateRoute from "./PrivateRoute";
import AdminRoute from "./AdminRoute";
import AccountManager from 'views/AccountManager';

export default class Routes extends Component {
  render() {
    return (
      <Switch>
        <Redirect
          exact
          from="/"
          to="/sign-in"
        />
        <PrivateRoute
          component={Dashboard}
          exact
          path="/dashboard"
        />
        <PrivateRoute
          component={Account}
          exact
          path="/account"
        />
        <PrivateRoute
          component={Support}
          exact
          path="/support"
        />
        <AdminRoute
          component={AccountManager}
          exact
          path="/account-manager"
        />
        <AdminRoute
          component={CustomerList}
          exact
          path="/cids"
        />
        <Route
          component={SignUp}
          exact
          path="/sign-up"
        />
        <Route
          component={SignIn}
          exact
          path="/sign-in"
        />
        <Route
          component={ForgotPassword}
          exact
          path="/password/forgot"
        />
        <Route
          component={ResetPassword}
          exact
          path="/password/reset/:token"
        />
        <Route
          component={UnderDevelopment}
          exact
          path="/under-development"
        />
        <Route
          component={NotFound}
          exact
          path="/not-found"
        />
        <Redirect to="/not-found" />
      </Switch>
    );
  }
}
